import './App.css';
import AllRoutes from './Routes/AllRoutes';

function App() {
  return (
    <div className="app">
      <AllRoutes/>
    </div>
  );
}

export default App;
